export default __webpack_public_path__ + "static/media/tronic.a3059244.png";